const EmergencyServiceMan = [
	{
		id: '5101',
        ac: 'd-block',
        dc: 'd-none',
		name: 'Topwear (Shirt / T-shirt / Fatua)',
		category: "Men's Wear",
		service: 'Emergency Service',
		subservice: 'Wash And Iron',
		price: 100,
		quantity: 1
	},
	{
		id: '5102',
        ac: 'd-block',
        dc: 'd-none',
		name: 'Topwear (Shirt / T-shirt / Fatua)',
		category: "Men's Wear",
		service: 'Emergency Service',
		subservice: 'Iron And Fold',
		price: 40,
		quantity: 1
	},
	{
		id: '5103',
        ac: 'd-block',
        dc: 'd-none',
		name: 'Topwear (Shirt / T-shirt / Fatua)',
		category: "Men's Wear",
		service: 'Emergency Service',
		subservice: 'Dry Cleaning',
		price: 100,
		quantity: 1
	},
	{
		id: '5104',
        ac: 'd-block',
        dc: 'd-none',
		name: 'Bottom Wear (Trouser / Jeans / Pajama)',
		category: "Men's Wear",
		service: 'Emergency service',
		subservice: 'Wash And Iron',
		price: 70,
		quantity: 1
	},
	{
		id: '5105',
        ac: 'd-block',
        dc: 'd-none',
		name: 'Bottom Wear (Trouser / Jeans / Pajama)',
		category: "Men's Wear",
		service: 'Emergency Service',
		subservice: 'Iron And Fold',
		price: 45,
		quantity: 1
	},
	{
		id: '5106',
        ac: 'd-block',
        dc: 'd-none',
		name: 'Bottom Wear (Trouser / Jeans / Pajama)',
		category: "Men's Wear",
		service: 'Emergency Service',
		subservice: 'Dry Cleaning',
		price: 100,
		quantity: 1
	},
	{
		id: '5107',
        ac: 'd-block',
        dc: 'd-none',
		name: 'Winter Wear (Sweater / Hoodies)',
		category: "Men's Wear",
		service: 'Emergency Service',
		subservice: 'Wash And Iron',
		price: 160,
		quantity: 1
	},
	{
		id: '5108',
        ac: 'd-block',
        dc: 'd-none',
		name: 'Winter Wear (Sweater / Hoodies)',
		category: "Men's Wear",
		service: 'Emergency Service',
		subservice: 'Iron And Fold',
		price: 85,
		quantity: 1
	},
	{
		id: '5109',
        ac: 'd-block',
        dc: 'd-none',
		name: 'Winter Wear (Sweater / Hoodies)',
		category: "Men's Wear",
		service: 'Emergency Service',
		subservice: 'Dry Cleaning',
		price: 210,
		quantity: 1
	},

	{
		id: '5110',
        ac: 'd-block',
        dc: 'd-none',
		name: 'Premium (Blazer / Coat / Jacket)',
		category: "Men's Wear",
		service: 'Emergency Service',
		subservice: 'Wash And Iron',
		price: 260,
		quantity: 1
	},
	{
		id: '5111',
        ac: 'd-block',
        dc: 'd-none',
		name: 'Premium (Blazer / Coat / Jacket)',
		category: "Men's Wear",
		service: 'Emergency Service',
		subservice: 'Iron And Fold',
		price: 160,
		quantity: 1
	},
	{
		id: '5112',
        ac: 'd-block',
        dc: 'd-none',
		name: 'Premium (Blazer / Coat / Jacket)',
		category: "Men's Wear",
		service: 'Emergency Service',
		subservice: 'Dry Cleaning',
		price: 320,
		quantity: 1
	},

	{
		id: '5113',
        ac: 'd-block',
        dc: 'd-none',
		name: 'Sherwani',
		category: "Men's Wear",
		service: 'Emergency Service',
		subservice: 'Wash And Iron',
		price: 450,
		quantity: 1
	},
	{
		id: '5114',
        ac: 'd-block',
        dc: 'd-none',
		name: 'Sherwani',
		category: "Men's Wear",
		service: 'Emergency Service',
		subservice: 'Iron And Fold',
		price: 250,
		quantity: 1
	},
	{
		id: '5115',
        ac: 'd-block',
        dc: 'd-none',
		name: 'Sherwani',
		category: "Men's Wear",
		service: 'Emergency Service',
		subservice: 'Dry Cleaning',
		price: 510,
		quantity: 1
	}
];
export default EmergencyServiceMan;
